import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Boletim',
    path: '/academico/boletim',
    name: 'boletim',
    component: () =>
      import('@/views/academico/boletimfichaindividual/BoletimFichaIndividualIndex.vue'),
    meta: {
      permissions: [eTipoPermissao.BOLETIM_MENU_300400150],
    },
    goesToMenu: true,
  },
  {
    description: 'Ficha Individual',
    path: '/academico/fichaindividual',
    name: 'fichaindividual',
    component: () =>
      import('@/views/academico/boletimfichaindividual/BoletimFichaIndividualIndex.vue'),
    meta: {
      permissions: [eTipoPermissao.FICHAINDIVIDUAL_MENU_300400450],
    },
  },
];
